import { Card, CardContent, CardHeader, CardTitle } from '../../../tailwind/card';
import { cn } from '../../../../lib/utils';
import { formatWalletCurrency } from '../../../../utils/wallet/walletUtils';
import { waSoft } from '../../../../pages/whatsapp/utils/whatsappUiTokens';

export function WalletTransactionLedger({ transactions }) {
  return (
    <Card className="bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between pb-3 border-b border-gray-200 dark:border-slate-800">
        <CardTitle className="text-lg text-gray-900 dark:text-white">Recent Transactions</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-gray-500 dark:text-gray-400 uppercase bg-slate-50 dark:bg-slate-950/60 border-b border-gray-200 dark:border-slate-800">
              <tr>
                <th className="px-6 py-3 font-medium">Date</th>
                <th className="px-6 py-3 font-medium">Type</th>
                <th className="px-6 py-3 font-medium">Description</th>
                <th className="px-6 py-3 font-medium text-right">Amount</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-slate-800">
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan={4} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
                    No transactions yet. Recharge your wallet to get started.
                  </td>
                </tr>
              ) : transactions.map((txn) => {
                const typeBadgeClass = txn.isPositive
                  ? waSoft.chip
                  : 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400';
                const amountClass = txn.isPositive
                  ? 'text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]'
                  : 'text-red-600 dark:text-red-400';
                const formattedAmount = txn.isPositive
                  ? `+${formatWalletCurrency(txn.amount)}`
                  : formatWalletCurrency(txn.amount);

                return (
                  <tr
                    key={txn.id}
                    className="hover:bg-slate-50/80 dark:hover:bg-slate-800/50 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-400">{txn.date}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', typeBadgeClass)}>
                        {txn.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-900 dark:text-gray-100 font-medium">{txn.description}</td>
                    <td className={cn('px-6 py-4 whitespace-nowrap text-right font-medium', amountClass)}>
                      {formattedAmount}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
